import { useCookieConsent, useCookieConsentOptional } from "../../context/CookieConsentContext";
import CookiePreferencesModal from "./CookiePreferencesModal";

export default function CookieConsentBanner() {
  const {
    bannerOpen,
    preferencesOpen,
    setPreferencesOpen,
    consent,
    acceptAll,
    rejectNonEssential,
    savePreferences,
    openPreferences,
  } = useCookieConsent();

  return (
    <>
      {bannerOpen && (
        <div
          className="fixed bottom-0 inset-x-0 z-[10000] p-4 sm:p-6"
          role="region"
          aria-label="Cookie consent"
        >
          <div className="mx-auto max-w-4xl rounded-2xl border border-gray-200 bg-white shadow-2xl p-5 sm:p-6 text-gray-900">
            <h2 className="text-base sm:text-lg font-semibold mb-2">
              We value your privacy
            </h2>
            <p className="text-sm text-gray-600 leading-relaxed mb-4">
              We use cookies and similar technologies to run VideoBrief, provide live support
              chat, and improve our services. California residents can accept, reject non-essential
              cookies, or customize choices — including opting out of sale or sharing of personal
              information. Read our{" "}
              <a href="/cookie-policy" className="underline text-blue-700">
                Cookie Policy
              </a>
              ,{" "}
              <a href="/privacy-policy" className="underline text-blue-700">
                Privacy Policy
              </a>
              , and{" "}
              <a href="/accessibility" className="underline text-blue-700">
                Accessibility Statement
              </a>
              .
            </p>
            <div className="flex flex-wrap gap-2">
              <button
                type="button"
                onClick={acceptAll}
                className="px-4 py-2.5 text-sm font-semibold rounded-lg bg-blue-600 text-white hover:bg-blue-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
              >
                Accept all
              </button>
              <button
                type="button"
                onClick={rejectNonEssential}
                className="px-4 py-2.5 text-sm font-semibold rounded-lg border border-gray-300 text-gray-800 hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
              >
                Reject non-essential
              </button>
              <button
                type="button"
                onClick={openPreferences}
                className="px-4 py-2.5 text-sm font-semibold rounded-lg border border-gray-300 text-gray-800 hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
              >
                Customize
              </button>
            </div>
          </div>
        </div>
      )}

      <CookiePreferencesModal
        open={preferencesOpen}
        onClose={() => setPreferencesOpen(false)}
        initial={consent}
        onSave={savePreferences}
      />
    </>
  );
}

/** Footer / in-page link to reopen preferences */
export function CookieSettingsLink({ className = "" }) {
  const ctx = useCookieConsentOptional();
  if (!ctx) {
    return (
      <a href="/cookie-policy" className={className}>
        Cookie settings
      </a>
    );
  }
  return (
    <button
      type="button"
      onClick={ctx.openPreferences}
      className={
        className ||
        "underline text-inherit bg-transparent border-0 p-0 cursor-pointer font-inherit"
      }
    >
      Cookie settings
    </button>
  );
}
